<div class="header">
    <h2>{{ 'licenses.modal.view.title' | translate }}</h2>
    <button type="button" [attr.aria-label]="'common.close' | translate" class="close" data-test="licenses-view-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'licenses.error.unavailable' | translate" />
} @else if (license(); as license) {
    <div class="body">
        <div class="entity-header">
            <div class="icon">
                <i class="pi pi-key"></i>
            </div>
            <div class="entity-identity">
                <h2>{{ 'licenses.detail.title' | translate }}</h2>
                <div class="tags">
                    @if (license.expired) {
                        <p-tag [value]="'licenses.status.expired' | translate" severity="secondary" />
                    } @else {
                        <p-tag [value]="'licenses.status.active' | translate" severity="success" />
                    }
                </div>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'licenses.fieldset.basic' | translate }}</h2>
            <div class="field">
                <span class="label">{{ 'licenses.form.packageId' | translate }}</span>
                <span class="value">{{ license.packageName }}</span>
            </div>
            <div class="field">
                <span class="label">{{ 'licenses.form.pricing' | translate }}</span>
                <span class="value">{{ license.pricing.label }}</span>
            </div>
            <div class="field">
                <span class="label">{{ 'licenses.form.startAt' | translate }}</span>
                <span class="value">{{ license.startAt | date: 'medium' }}</span>
            </div>
            <div class="field">
                <span class="label">{{ 'licenses.form.endAt' | translate }}</span>
                <span class="value">{{ license.endAt | date: 'medium' }}</span>
            </div>
            <div class="field">
                <span class="label">{{ 'licenses.form.status' | translate }}</span>
                <span class="value">{{ 'licenses.status.' + license.status | translate }}</span>
            </div>
            <div class="field">
                <span class="label">{{ 'licenses.form.autoRenewal' | translate }}</span>
                <span class="value">{{ (license.autoRenewal ? 'common.yes' : 'common.no') | translate }}</span>
            </div>
            @if (license.cancelledAt) {
                <div class="field">
                    <span class="label">{{ 'licenses.form.cancelledAt' | translate }}</span>
                    <span class="value">{{ license.cancelledAt | date: 'medium' }}</span>
                </div>
            }
        </div>

        <div class="section">
            <h2>{{ 'licenses.fieldset.relatedEntity' | translate }}</h2>
            <app-entity-list [ids]="[license.relatedEntityId]" [type]="license.relatedEntityType" emptyKey="licenses.relatedEntity.empty" />
        </div>
    </div>

    <div class="footer">
        <p-button [label]="'licenses.detail.edit' | translate" icon="pi pi-pencil" data-test="licenses-view-edit" (onClick)="onEdit(license.id)" />
    </div>
}
